<div class="fleet-management-preview"
     [class.device-desktop]="deviceType === 'desktop'"
     [class.device-tablet]="deviceType === 'tablet'"
     [class.device-mobile]="deviceType === 'mobile'">
  <div class="modern-subpage-hero">
  <!-- Page Header Section (contains header inside) -->
  <section 
    class="page-header-section website-element fleets-page-header-element" 
    *ngIf="isSectionVisible('page-title')"
    [class.selected]="getFleetSectionElement()?.selected"
    (click)="onPageHeaderSectionClick($event)">
    
    <!-- Header Section inside Page Header Section -->
    <div class="page-header-header-wrapper" (click)="onHeaderClick()">
      <div class="website-element header-element" 
           *ngIf="isSectionVisible('header')"
           [class.selected]="getHeaderElement()?.selected">
        <app-modern-page-header
          [logo]="getHeaderLogo()"
          [navigation]="getHeaderNavigation()"
          [ctaButton]="getHeaderCTAButton()"
          [visible]="true"
          [clickable]="true"
          [selected]="getHeaderElement()?.selected || false"
          [headingColor]="headingColor"
          [headingFont]="headingFont"
          [backgroundColor]="getHeaderBackgroundColor()"
          (navigationClick)="onNavigationClick($event)">
        </app-modern-page-header>
      </div>
    </div>

    <!-- Page Header Content -->
    <div class="page-header-content-wrapper">
      <div class="page-header-container">
        <h1 class="section-title"
            [style.color]="getHeadingColor()"
            [style.font-family]="getHeadingFont()"
            [ngStyle]="getTitleStyles()">{{ getPageTitle() }}</h1>
        <p class="section-subtitle"
           [style.color]="getParagraphColor()"
           [style.font-family]="getBodyFont()">{{ getPageSubtitle() }}</p>
      </div>
    </div>
  </section>

  <!-- Form Section -->
  <section 
    class="form-section website-element fleets-form-element" 
    *ngIf="isSectionVisible('form_section')"
    [class.selected]="getFleetSectionElement()?.selected"
    (click)="onFormSectionClick($event)">
    <div class="form-container">
      <form class="fleet-form" (ngSubmit)="onSubmit()">
        <!-- Row 1: Company Name and Your Name -->
        <div class="form-row">
          <div class="form-group">
            <label for="company_name" class="form-label">Company Name</label>
            <input 
              type="text" 
              id="company_name"
              name="company_name"
              class="form-input"
              placeholder="eg. Ema"
              [(ngModel)]="formData.company_name"
              required>
          </div>
          <div class="form-group">
            <label for="contact_name" class="form-label">Your Name</label>
            <input 
              type="text" 
              id="contact_name"
              name="contact_name"
              class="form-input"
              placeholder="John Smith"
              [(ngModel)]="formData.contact_name"
              required>
          </div>
        </div>

        <!-- Row 2: Phone Number and Email -->
        <div class="form-row">
          <div class="form-group">
            <label for="phone" class="form-label">Phone Number</label>
            <input 
              type="tel" 
              id="phone"
              name="phone"
              class="form-input"
              placeholder="(123) 456-7890"
              [(ngModel)]="formData.phone"
              required>
          </div>
          <div class="form-group">
            <label for="email" class="form-label">Email</label>
            <input 
              type="email" 
              id="email"
              name="email"
              class="form-input"
              placeholder="john@example.com"
              [(ngModel)]="formData.email"
              required>
          </div>
        </div>

        <!-- Row 3: Wash Type and No of Vehicle -->
        <div class="form-row">
          <div class="form-group">
            <label for="wash_type" class="form-label">Wash Type</label>
            <select 
              id="wash_type"
              name="wash_type"
              class="form-select"
              [(ngModel)]="formData.wash_type"
              required>
              <option value="" disabled selected>Select wash type</option>
              <option *ngFor="let package of packages; trackBy: trackById" [value]="package.package_name">
                {{ package.package_name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="vehicle_count" class="form-label">No of Vehicle</label>
            <input 
              type="number" 
              id="vehicle_count"
              name="vehicle_count"
              class="form-input"
              placeholder="eg. 20"
              [(ngModel)]="formData.vehicle_count"
              min="1"
              required>
          </div>
        </div>

        <!-- Row 4: Special Requests (Full Width) -->
        <div class="form-group form-group-full">
          <label for="notes" class="form-label">Special Requests or Notes</label>
          <textarea 
            id="notes"
            name="notes"
            class="form-textarea"
            placeholder="Any special requests or vehicle details."
            [(ngModel)]="formData.notes"
            rows="5"></textarea>
        </div>

        <!-- Submit Button -->
        <button type="submit"
                class="submit-button"
                [style.background-color]="getPrimaryColor()"
                [style.color]="getHeadingColor()"
                [disabled]="submitting">
          <span *ngIf="!submitting">{{ getButtonText() }}</span>
          <span *ngIf="submitting">Submitting...</span>
        </button>
      </form>
    </div>
  </section>
  </div>

  <!-- Footer -->
  <div class="website-element footer-element" 
       *ngIf="isSectionVisible('footer')"
       [class.selected]="getFooterElement()?.selected"
       (click)="onFooterClick($event)">
    <app-modern-page-footer 
      [quickLinks]="getFooterQuickLinks()"
      (quickLinkClick)="onNavigationClick($event)"
      [quickLinksTitle]="getFooterQuickLinksTitle()"
      [socialLinks]="getFooterSocialLinks()"
      [socialLinksTitle]="getFooterSocialLinksTitle()"
      [copyright]="getFooterCopyright()"
      [logo]="getFooterLogo()"
      [backgroundColor]="getFooterBackgroundColor()">
    </app-modern-page-footer>
  </div>
</div>
